import { cva } from 'class-variance-authority';

/**
 * A value already picked, drawn as a pill with an × on it.
 *
 * Classes rather than a component, because the two fields that draw chips do
 * not build them from the same elements: `Combobox` owns its markup outright,
 * while `SearchSelect` hands the job to Base UI's own chip parts, which bring
 * their own roles and their own arrow-key behaviour. An element shared between
 * them would have to be fought by one of the two; the look is the whole
 * overlap, so the look is what is shared.
 *
 * `data-highlighted` is Base UI's state for the chip the arrow keys are on. The
 * static combobox never sets it, so the rule simply never fires there.
 */
export const chipVariants = cva(
  'inline-flex max-w-full items-center gap-1 rounded-full bg-fill py-1 pr-1 pl-2.5' +
    ' text-sm font-semibold text-ink outline-none data-highlighted:bg-line',
);

/** The × inside a chip. Turns red on hover: the press takes the value away. */
export const chipRemoveVariants = cva(
  'shrink-0 rounded-full p-0.5 text-ink-muted transition hover:bg-danger-fill hover:text-danger' +
    ' focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ink-faint',
);
